var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.84805 14.4793C3.97988 14.4793 0.837001 11.3342 0.839846 7.46684C0.84269 3.59946 3.99411 0.454377 7.85658 0.462908C11.7219 0.471439 14.8534 3.60515 14.8562 7.46968C14.8591 11.3399 11.7162 14.4821 7.84805 14.4793ZM7.8452 13.3106C11.0592 13.3191 13.6759 10.7058 13.6844 7.48105C13.693 4.26772 11.0791 1.64587 7.85943 1.63734C4.64544 1.62881 2.02874 4.2336 2.01167 7.4583C1.99461 10.6745 4.61699 13.302 7.8452 13.3106Z",
    fill: "#874B69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69141 7.48664C6.69141 6.80985 6.69425 6.13306 6.69141 5.45627C6.69141 5.2885 6.72269 5.14347 6.88481 5.061C7.04693 4.97569 7.1863 5.0411 7.31998 5.13778C8.2472 5.81173 9.17442 6.48568 10.0988 7.15962C10.3775 7.36152 10.3718 7.61176 10.096 7.81366C9.16589 8.49045 8.23298 9.1644 7.30292 9.84119C7.17493 9.93503 7.04125 9.98053 6.89335 9.90944C6.73691 9.83551 6.69425 9.69901 6.69425 9.53408C6.69425 8.84876 6.69141 8.16912 6.69141 7.48664Z",
    fill: "#874B69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup7);
export default __webpack_public_path__ + "static/media/Group (7).ad540adb8864c1da2db0c94bc1bbcf92.svg";
export { ForwardRef as ReactComponent };